function scrollToBgIfSingleNews() {
    if (document.body.classList.contains('single-news')) {
        const bgElement = document.querySelector('.bg');
        if (bgElement) {
            const rect = bgElement.getBoundingClientRect();
            let top = window.pageYOffset + rect.top;
            const navHeight = document.querySelector('.nav')?.offsetHeight || 0;
            top -= navHeight;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }
}

document.addEventListener("DOMContentLoaded", scrollToBgIfSingleNews);


